import { NgModule } from '@angular/core'

import { ApiClient } from './services/api.client'
import { ApiService } from './services/api.service'

@NgModule({
  providers: [ApiService, ApiClient],
})
export class ApiModule {}
